import { fromJS } from 'immutable';
import { ALERT, CLOSE } from './constants';

export const initialState = fromJS({
  alert: null,
  isOpen: false
});

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case ALERT: {
      return state.set('alert', fromJS(payload)).set('isOpen', true);
    }

    case CLOSE: {
      return state.set('isOpen', false);
    }

    default:
      return state;
  }
}
